import { useQuery } from '@tanstack/react-query';

import { getSalesforceStatus } from '../api/status';
import type { SalesforceStatusResponse } from '../types';

export function useSalesforceStatus(orgId: number | string | undefined) {
  return useQuery<SalesforceStatusResponse>({
    queryKey: ['salesforceStatus', orgId],
    queryFn: () => {
      if (!orgId) {
        throw new Error('orgId is required');
      }
      return getSalesforceStatus(orgId);
    },
    enabled: !!orgId,
    refetchInterval: query => {
      const { data } = query.state;
      if (!data?.connected) {
        return false;
      }
      if (data?.import_jobs?.some(job => job.status === 'active')) {
        return 5000;
      }
      return 30000;
    },
  });
}
